import React from 'react';
import Head from "next/head";

const FaqSchema = ({faqs}) => {
    return (
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{__html: JSON.stringify(getStructuredData(faqs))}}
            />
        </Head>
    );
};

export default FaqSchema;


function getStructuredData(faqs) {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": getFaqs(faqs),
    };
}

function getFaqs(faqs) {
    let items = [];

     if (faqs.length) {
         for (let faq of faqs) {
             items.push({
                 "@type": "Question",
                 "name": faq.caption,
                 "acceptedAnswer": getAnswer(faq),
             })
         }
     }

    return items;
}

function getAnswer(faq) {
    return {
        "@type": "Answer",
        "text": faq.content,
    };
}